import { Component, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';

@Component({
  selector: 'app-commen-alertpage',
  templateUrl: './commen-alertpage.page.html',
  styleUrls: ['./commen-alertpage.page.scss'],
})
export class CommenAlertpagePage implements OnInit {

  msg: any;
  status: any;
  closemodel: boolean;

  constructor(public modalCtrl: ModalController) { }

  ngOnInit() {
  }

  ionViewWillEnter() {
    this.closemodel = false;
    this.cloasemodel();
  }

  ondismiss() {
    if (this.closemodel == true)
      this.modalCtrl.dismiss(true)
  }

  cloasemodel() {
    // setTimeout(() => {
    this.closemodel = true;
    this.ondismiss();
    // }, 2000);
  }







}
